import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { isViewerRole } from 'src/app/core/model/tenants/user-profile.model';
import { TenantClientService } from 'src/app/core/services/tenant-client.service';

/** Blocks the viewer role from create/edit routes — a form a viewer can't submit
 *  (every write is already rejected server-side) shouldn't be shown at all. Fetches
 *  the profile fresh, same rationale as adminGuard: AppService's cached copy may not
 *  have settled yet for the tenant being navigated to. */
export const notViewerGuard: CanActivateFn = (route) => {
  const tenantClient = inject(TenantClientService);
  const router = inject(Router);
  const tenantCode = route.paramMap.get('tenantCode');

  if (!tenantCode) {
    return true;
  }

  return tenantClient.getUserProfile(tenantCode).pipe(
    map((profile) => !isViewerRole(profile.role) || router.createUrlTree(['/', tenantCode])),
    catchError(() => of(router.createUrlTree(['/', tenantCode]))),
  );
};
